/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function SEO({
  description,
  lang,
  meta,
  title,
  canonicalUrlPath,
  image,
  pathname,
  isDynamicImage,
}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            image
            siteUrl
            social {
              twitter
              image
            }
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  let metaImage

  if (image) {
    if (isDynamicImage) {
      metaImage = image
    } else {
      metaImage = `https://wealthybites.io${image}`
    }
  } else {
    metaImage = site.siteMetadata.image
  }

  const metaTitle = title || site.siteMetadata.title
  let url = pathname && `${site.siteMetadata.siteUrl}${pathname}`
  if (url && !url.endsWith("/")) {
    url += "/"
  }

  let canonicalUrl = `${site.siteMetadata.siteUrl}${canonicalUrlPath}`
  if (!canonicalUrl.endsWith("/")) {
    canonicalUrl += "/"
  }

  return (
    <Helmet>
      <html lang={lang} amp />
      <title itemProp="name" lang="en">
        {metaTitle}
      </title>
      <link rel="canonical" href={canonicalUrl} />
      <meta name="description" content={metaDescription} />

      {/* Open Graph Tags */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content="en_GB" />
      {/* End Open Graph Tags */}

      {/* Twitter OG tags */}
      <meta property="twitter:card" content="summary_large_card" />
      <meta
        property="twitter:site"
        content={site.siteMetadata.social.twitter}
      />
      <meta property="twitter:image" content={metaImage} />
      <meta property="twitter:title" content={metaTitle} />
      <meta property="twitter:description" content={metaDescription} />
      {/* End Twitter OG tags */}

      {/* Custom Scripts */}
      {/* End Custom Scripts */}
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
